import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';


const ToastBodyWithDetails = ({ header, intro, children, onModalClose }) => {
    const [showModal, setShowModal] = useState(false);
    const [autoHide, setAutoHide] = useState(true);
    const [progress, setProgress] = useState(0);
    const hideTimeout = React.useRef();
    const progressInterval = React.useRef();

    React.useEffect(() => {
        if (!autoHide) return;
        setProgress(0);
        let start = Date.now();
        progressInterval.current = setInterval(() => {
            const elapsed = Date.now() - start;
            setProgress(Math.min(100, (elapsed / 5000) * 100));
        }, 30);
        hideTimeout.current = setTimeout(() => {
            if (onModalClose) onModalClose();
        }, 5000);
        return () => {
            clearTimeout(hideTimeout.current);
            clearInterval(progressInterval.current);
        };
    }, [autoHide, onModalClose]);

    const closeModal = () => {
        setShowModal(false);
        onModalClose?.();
    };

    const handleShowDetails = () => {
        setShowModal(true);
        setAutoHide(false); // Cancel auto-hide if user clicks details
    };

    return (
        <div style={{ display: 'block', width: '100%' }}>
            <div style={{ position: 'relative' }}>
                <div className="mb-2"><strong>{header}</strong></div>
                <div>{intro}</div>
                {children &&
                    <button
                        onClick={handleShowDetails}
                        className="btn btn-sm btn-link p-0 mt-2"
                    >
                        Show Details
                    </button>
                }
                {/* Progress bar absolutely positioned at bottom of toast content only */}
                {autoHide && (
                    <>
                    <div>&nbsp;</div>
                    <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 4, background: '#eee', overflow: 'hidden', borderRadius: 2, zIndex: 2 }}>
                        <div style={{ height: '100%', width: `${100-progress}%`, background: 'linear-gradient(90deg, #ffc107, #ff9800)', transition: 'width 0.1s linear', borderRadius: 2 }} />
                    </div>
                    </>
                )}
            </div>
            <Modal isOpen={showModal} toggle={closeModal} size="lg">
                <ModalHeader toggle={closeModal}>
                    {header}
                </ModalHeader>
                <ModalBody>                    
                    <div className="mb-4 fw-bold">{intro}:</div>
                    <div>{children}</div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeModal}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ToastBodyWithDetails;
